import React from 'react';

import MotifChip from '@ey/motif-react-wrapper/Chip';

import StyledChip from './StyledChip';

const ColoredChip = ({containerClassName, ...otherProps}) => (
	<StyledChip className={containerClassName}>
		<MotifChip {...otherProps} />
	</StyledChip>
);

export default ColoredChip;
